import { render, staticRenderFns } from "./ModalCard.vue?vue&type=template&id=272008e2&scoped=true&"
import script from "./ModalCard.vue?vue&type=script&lang=js&"
export * from "./ModalCard.vue?vue&type=script&lang=js&"
import style0 from "./ModalCard.vue?vue&type=style&index=0&id=272008e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272008e2",
  null
  
)

export default component.exports